import { render, staticRenderFns } from "./EventTypeEditDialog.vue?vue&type=template&id=3a0f7705&scoped=true"
import script from "./EventTypeEditDialog.vue?vue&type=script&lang=js"
export * from "./EventTypeEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0f7705",
  null
  
)

export default component.exports